import { Component, OnInit,ViewChild  } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import * as firebase from 'firebase';
import{ServicioFechasQueryService} from '../servicio-fechas-query.service'
import {ModalDataUsuarioComponent } from '../modal-data-usuario/modal-data-usuario.component'



@Component({
  selector: 'app-componente-data1',
  templateUrl: './componente-data1.component.html',
  styleUrls: ['./componente-data1.component.scss']
})
export class ComponenteData1Component implements OnInit {

  tablavisible = false;
  dtTrigger = new Subject();

  dtOptions: any = {};

  arraydeposts: any[] = [];
  excelOTabla = 'tabla';
  pageSize: number = 20;
  cursor: any;
  infiniteEvent: any;

  fechaquerymin;
  fechaquerymax;

  constructor( public servicioFechasQueryService:ServicioFechasQueryService, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.tablavisible=false
    // this.cargapedidos()
  }

  generarReporte(){
    this.fechaquerymin = this.servicioFechasQueryService.fechaquerymin
    this.fechaquerymax = this.servicioFechasQueryService.fechaquerymax
    this.cargapedidos()
  }

  cargapedidos() {
    this.borra(() => {
      this.dtTrigger = new Subject();
      // this.presentLoading("Cargando pedidos...");
      this.reseteaarray(() => {

        if(this.excelOTabla=='tabla'){
          this.tablavisible = true;
        }
        
        this.inicializadatatables(() => {

        
            this.query1(() => {
              this.dtTrigger.next();// //este trigger vuelve a dibujar la tabla. se invoca cuando hay un cambio en la tabla
              // this.loadingController.dismiss();
            })
          

        })
      })
    })
  }//fin de getposts

 


  query1(callback){
    this.arraydeposts=[];
    console.log(this.fechaquerymin +"---"+ this.fechaquerymax)
    let query1 = firebase.firestore().collection("autodiagnosticos").where("fecha", ">=", this.fechaquerymin).where("fecha", "<=", this.fechaquerymax).orderBy("fecha", "desc");
    
    query1.get().then((docs)=>{
      docs.forEach((doc)=>{
        this.arraydeposts.push(doc);
      })
    }).catch((err)=>{
      console.log(err);
    }).then(()=>{
      callback()
    })
  }




borra(callback) {
  this.arraydeposts=[];
  this.dtTrigger.unsubscribe();
  this.tablavisible = false;
  callback()
}


reseteaarray(callback) {
  this.arraydeposts = [];
  callback();
}

inicializadatatables(callback) {
  this.dtOptions = {
    // Declare the use of the extension in the dom parameter
    dom: 'Bfrtip',
    "pageLength": 200,
    scrollX: true,
 
    // Configure the buttons
    buttons: [
      'colvis',
      'excel',
      // 'columnsToggle',
      'print'
    ]
  };
  callback()
}


detallesUsuario(cedula){
      const modalRef = this.modalService.open(ModalDataUsuarioComponent);
      modalRef.componentInstance.cedula = cedula;//pasamos al modal el parámetro de cedula

      //para recibir data desde el modal
      modalRef.result.then((result) => {
        if (result) {
        console.log(result);
        }
        });

}




  
}//fin de clase



